import { z } from 'zod';

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .max(254)
  .pipe(z.email({ message: 'Enter a valid email address' }));

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .max(128, 'Password must be at most 128 characters')
  .regex(/[A-Za-z]/, 'Password must contain a letter')
  .regex(/[0-9]/, 'Password must contain a number');

export const nameSchema = z.string().trim().min(1, 'Name is required').max(100);

export const registerSchema = z.object({
  email: emailSchema,
  name: nameSchema,
  password: passwordSchema,
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Password is required').max(128),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({ email: emailSchema });
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const tokenSchema = z.string().min(20).max(200);

export const resetPasswordSchema = z.object({ token: tokenSchema, password: passwordSchema });
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const verifyEmailSchema = z.object({ token: tokenSchema });

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: passwordSchema,
});
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export const updateProfileSchema = z.object({
  name: nameSchema.optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const kingschatLoginSchema = z.object({
  accessToken: z.string().min(1, 'Access token is required'),
});
export type KingschatLoginInput = z.infer<typeof kingschatLoginSchema>;

export const addEmailSchema = z.object({
  email: emailSchema,
});
export type AddEmailInput = z.infer<typeof addEmailSchema>;

export const magicLinkSchema = z.object({
  email: emailSchema,
  callbackUrl: z.string().optional(),
});
export type MagicLinkInput = z.infer<typeof magicLinkSchema>;

export const neonSessionSchema = z.object({
  sessionToken: z.string().optional(),
  email: emailSchema.optional(),
  name: z.string().optional(),
  neonUserId: z.string().optional(),
  verifier: z.string().optional(),
});
export type NeonSessionInput = z.infer<typeof neonSessionSchema>;
